import React from 'react';
import { GridColumns } from '@material-ui/data-grid';
import { useAuth } from '@domain/auth/auth.hook';
import { CancelToken } from 'axios';
import { formatColWithDate } from '@components/datagrid/custom.datagrid.props';
import { noopArray } from '@domain/utils/function.utils';
import { MainDataGrid } from '@components/datagrid/main.data.grid';
import { usePagedData } from '@domain/hooks/use.paged.data';
import { JackpotTable } from '@screens/jackpot.winners/jackpot.winners.styles';
import { DiffsFormSchema } from '@screens/players/player.details.tabs/diffs/diffs.form.data';
import { JackpotWinnersFormData, JackpotWinnersFormSchema } from '@screens/jackpot.winners/jackpot.winners.form.data';

const columns: GridColumns = [
  { field: 'pid', headerName: 'Pid', width: 100 },
  { field: 'cash', headerName: 'Cash', width: 110 },
  { field: 'coins', headerName: 'Coins', width: 130 },
  { field: 'timestamp', headerName: 'Timestamp', ...formatColWithDate, width: 170 },
  { field: 'firstName', headerName: 'First Name', width: 179 },
  { field: 'uid', headerName: 'Uid' },
  { field: 'sex', headerName: 'Sex' },
  { field: 'lastPlatform', headerName: 'Platform', width: 140 },
  { field: 'percentage', headerName: 'Percentage', width: 150 },
  { field: 'gameId', headerName: 'gameId', width: 130 },
  { field: 'pix', headerName: 'Pix' },
];

interface JackpotsData {
  pid: number;
}
let index = 0;
function createData(jackpotsData: JackpotsData) {
  index += 1;
  return { id: index, ...jackpotsData };
}

interface GameIDataProps {
  gameId?: string;
  app?: string;
}

const JackpotWinnersList = (props: GameIDataProps) => {
  const { authorizedServices } = useAuth();

  async function runSearch(data: any, page: number, cancelToken: CancelToken | undefined) {
    await JackpotWinnersFormSchema.validate(data, { abortEarly: false });
    return authorizedServices.get<JackpotsData[]>('/admin/jackpot/list', { params: { ...data, page }, cancelToken });
  }

  const { responseData, pageCount, loading, error } = usePagedData(props, runSearch, {
    placeholderData: noopArray,
  });

  const rows = responseData?.map(createData) || [];
  return (
    <JackpotTable>
      <MainDataGrid columns={columns} rows={rows} loading={loading} error={error} pageCount={pageCount} />
    </JackpotTable>
  );
};

export default JackpotWinnersList;
